import { render, staticRenderFns } from "./YezzaPickList.vue?vue&type=template&id=9bba86b6&scoped=true&lang=pug&"
import script from "./YezzaPickList.vue?vue&type=script&lang=js&"
export * from "./YezzaPickList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bba86b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
